import styled from 'styled-components';

import { breakpoints } from '~/design-tokens/breakpoints/breakpoints';

export const Logo = styled.img`
  width: 103px;
`;

export const LogoMini = styled.img`
  height: 20px;
  width: 30px;
  position: absolute;
  left: 39px;
  top: 0;
  opacity: 0;
`;

export const HeaderLogotypeRoot = styled.div`
  position: relative;
  min-width: 50px;
  height: 20px;

  ${Logo} {
    display: none;
    opacity: 0;
    img {
      width: 50px;
    }
    @media ${breakpoints.xl} {
      opacity: 1;
      display: block;
    }
  }

  ${LogoMini} {
    opacity: 1;
    @media ${breakpoints.xl} {
      opacity: 0;
    }
  }
`;
